module.exports = __webpack_public_path__ + "img/desktop_custom.aabf0dc8.jpg";